import { useEffect} from "react"
import { usePhotoBlobs } from "globalState"


export const useInitialFetchPhotos = ()=>{
  const [, ,addPhotos] = usePhotoBlobs()
  
  useEffect(()=>{
    addPhotos()
  }, [])
}